module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("\n        " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('mini-calc-icons'), _vm._v(" "), _c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": '#' + _vm.icon
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-clear"
  }), _c('br'), _vm._v(" "), _c('h2', [_vm._v("\n        Summary\n    ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7bcf14fd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mini-calculators/components/MiniCalculatorHeader.vue
// module id = 1758
// module chunks = 0